import { useState, useEffect } from "react";
import Axios from "axios";
import {
  requestForToken,
  setupForegroundNotification,
} from "../../app/firebase";

async function registerFcmToken(setToken) {
  setupForegroundNotification();
  const fcmToken = await requestForToken();
  if (fcmToken) {
    setToken(fcmToken);
    Axios.post("/api/device-tokens", { token: fcmToken, platform: "WEB" })
      .then(() => console.log("[FCM] Token registrado correctamente"))
      .catch((e) => console.error("[FCM] Error al registrar token:", e));
  }
}

export const useFirebaseToken = () => {
  const [token, setToken] = useState("");
  const [notificationStatus, setNotificationStatus] = useState("pending");

  useEffect(() => {
    if (!("Notification" in window)) {
      setNotificationStatus("unsupported");
      return;
    }
    // Si ya está concedido, registrar token directamente sin volver a pedir permiso
    if (Notification.permission === "granted") {
      setNotificationStatus("granted");
      registerFcmToken(setToken).catch(console.error);
    } else {
      setNotificationStatus(Notification.permission); // "default" o "denied"
    }
  }, []);

  // Llamar esto desde un botón (user gesture) para que Chrome muestre el prompt
  const askPermission = async () => {
    try {
      if (!("Notification" in window)) return;
      const permission = await Notification.requestPermission();
      setNotificationStatus(permission);
      if (permission === "granted") {
        await registerFcmToken(setToken);
      }
    } catch (e) {
      console.error("[FCM] Error solicitando permiso:", e);
      setNotificationStatus("error");
    }
  };

  return { token, notificationStatus, askPermission };
};
